import * as Types from '../../../types/schema.generated';

import gql from 'graphql-tag';
import { MemberManagementFormFragmentDoc } from '../../../components/organisms/MemberManagementForm/MemberManagemenetForm.generated';
export type SettingsPageMemberManagementUpdateContentViewStaffFragment = { __typename?: 'Staff', guid: string, name?: string | null, email: string, role: Types.StaffRole };

export type SettingsPageMemberManagementUpdateContentViewQueryFragment = { __typename?: 'Query', planner?: { __typename?: 'Planner', id: string, email: string } | null, viewer: { __typename?: 'Viewer', staff: { __typename?: 'Staff', guid: string } }, teams: Array<{ __typename?: 'Team', guid: string, name: string }> };

export const SettingsPageMemberManagementUpdateContentViewStaffFragmentDoc = gql`
    fragment SettingsPageMemberManagementUpdateContentViewStaff on Staff {
  guid
  name
  email
  role
}
    `;
export const SettingsPageMemberManagementUpdateContentViewQueryFragmentDoc = gql`
    fragment SettingsPageMemberManagementUpdateContentViewQuery on Query {
  ...MemberManagementForm
  planner {
    id
    email
  }
  viewer {
    staff {
      guid
    }
  }
}
    ${MemberManagementFormFragmentDoc}`;